import axiosInstance from '../superadminAxiosInstance';
import { BaseService } from './baseService';

class SenderNamesService extends BaseService<
	SenderName,
	'senderNameID',
	'senderNames'
> {
	constructor() {
		super('senderNameID', 'senderName', 'senderNames');
	}

	async deleteMultiple(
		data: DeleteMultipleSenderNamesRequest[],
	): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/batch`,
			data,
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SenderNamesService();
